import React, { useState, useEffect } from 'react';
import emptyIllustration from '../../../../../../assets/illustration/empty-material.png'; // use correct path
import '../../../../../../Stylesheets/Dashboard/Tabs/Materials/Materials.css';
import AddMaterialModal from './Component/AddMaterialModal';
import UploadBillModal from './Component/UploadBillModal';
import MaterialActionPanel from './Component/MaterialActionPanel';
import MaterialInventoryTable from './Component/MaterialInventoryTable';
import SmartSuggestions from './Component/SmartSuggestions';
import RecentActivity from './Component/RecentActivity';
import { toast } from 'react-toastify';
import MaterialTransactionModal from './Component/MaterialTransactionModal';
import EmptyState from "../../../../../../Components/Common/EmptyState";

import ViewMaterialDrawer from './Component/ViewMaterialDrawer';

import ViewUsageLogModal from './Component/ViewUsageLogModal';
import MaterialReportModal from './Component/MaterialReportModal';

// at top with other icons (optional)
import { FiZap } from 'react-icons/fi';
import { FaPlus, FaClipboardList } from 'react-icons/fa';

import { useDispatch, useSelector } from 'react-redux';
import {
  fetchMaterialsByProject,
  fetchMaterialDetails,
  clearMaterialDetails,
  resetRecentMaterialActivity,
  fetchRecentMaterialActivity,
  fetchMoreMaterialActivity,
  fetchMaterialOverview,
  deleteMaterialById, restoreMaterialById
} from '../../../../../../Redux/Projects/Material/materialSlice';

import { useNavigate } from 'react-router-dom';

import axiosWithAuth from '../../../../../../Redux/UtilsRedux/axiosWithAuth';
import { API_ROUTES } from '../../../../../../Redux/Constants/apiRoutes';

import { showFeedback } from '../../../../../../Redux/UI/uiFeedbackSlice';


const Materials = ({ currentProjectId }) => {


  const dispatch = useDispatch();

  const navigate = useNavigate();

  const [showReportModal, setShowReportModal] = useState(false);
  const [reportFrom, setReportFrom] = useState('');
  const [reportTo, setReportTo] = useState('');
  const [reportCategory, setReportCategory] = useState('all');
  const [reportDetail, setReportDetail] = useState('summary'); // 'summary' | 'detailed'


  // NEW: boot loader + loaded flag
  const [initialLoad, setInitialLoad] = useState(true);
  const [showAddModal, setShowAddModal] = useState(false);
  const [showUploadModal, setShowUploadModal] = useState(false);
  const [newMaterial, setNewMaterial] = useState(null); // just added material

  const [transactionMode, setTransactionMode] = useState(null);
  const [transactionMaterial, setTransactionMaterial] = useState(null);
  const [selectedMaterialId, setSelectedMaterialId] = useState(null);
  const materialDetails = useSelector((state) => state.materials.materialDetails);
  const materialDetailsLoading = useSelector((state) => state.materials.materialDetailsLoading);
  const { recentActivity, recentActivityNextCursor, recentActivityLoading } = useSelector((s) => s.materials);

  const { materials = [], loading, overview, overviewLoading } = useSelector((s) => ({
    materials: s.materials.materials,
    loading: s.materials.loading,
    overview: s.materials.overview,
    overviewLoading: s.materials.overviewLoading,
  }));

  const [confirmBox, setConfirmBox] = useState(null);
  // confirmBox = { title, message, onYes }

  const askConfirm = ({ title, message, onYes }) => {
    setConfirmBox({ title, message, onYes });
  };



  const [showUsageLogModal, setShowUsageLogModal] = useState(false);
  const [logMaterial, setLogMaterial] = useState(null);
  const [logModalData, setLogModalData] = useState(null);


  useEffect(() => {
    // whenever project changes, kill any open overlays
    setShowAddModal(false);
    setShowUploadModal(false);
    setNewMaterial(null);

    setTransactionMode(null);
    setTransactionMaterial(null);
    setLogModalData(null);

    setSelectedMaterialId(null);
    setShowUsageLogModal(false);
    setLogMaterial(null);

    setShowReportModal(false);
  }, [currentProjectId]);


  useEffect(() => {
    if (!currentProjectId) return;

    let alive = true;
    setInitialLoad(true);

    // ✅ prevent old project's activity from flashing
    dispatch(resetRecentMaterialActivity());

    const p1 = dispatch(fetchMaterialsByProject(currentProjectId)).unwrap().catch(() => { });
    const p2 = dispatch(fetchMaterialOverview(currentProjectId)).unwrap().catch(() => { });
    const p3 = dispatch(fetchRecentMaterialActivity({ projectId: currentProjectId, limit: 4 }))
      .unwrap()
      .catch(() => { });

    Promise.allSettled([p1, p2, p3]).then(() => {
      if (!alive) return;
      setTimeout(() => alive && setInitialLoad(false), 250);
    });

    return () => { alive = false; };
  }, [currentProjectId, dispatch]);


  // const { materials = [], loading } = useSelector((state) => state.materials);



  const [suggestionData, setSuggestionData] = useState([
    { text: 'Cement received on 25 Mar — no usage logged.' },
    { text: 'Cement received on 25 Mar — no usage logged.' },
    { text: 'Cement received on 25 Mar — no usage logged.' },
  ]);


  const fmtINR = (n) => `₹${(Number(n || 0)).toLocaleString('en-IN')}`;
  const fmtDate = (iso) =>
    new Date(iso).toLocaleDateString('en-GB', { day: '2-digit', month: 'short' });

  const uiLogs = (recentActivity || []).map(item => ({
    date: fmtDate(item.createdAt),
    message: item.message,
    type:
      item.type === 'material_receive' ? 'received' :
        item.type === 'material_usage' ? 'issued' :
          item.type === 'material_bill' ? 'uploaded' : 'other',
  }));




  // ✅ HARD GATE: show loader first, nothing else
  if (initialLoad) {
    return (
      <div className="material-tab-loading">
        <div className="material-tab-loading-card">
          <div className="material-spinner" />
          <p>Loading materials…</p>
        </div>
      </div>
    );
  }



  const handleRemoveSuggestion = (idxToRemove) => {
    const updated = [...suggestionData];
    updated.splice(idxToRemove, 1);
    setSuggestionData(updated);
  };




  const handleAddMaterial = (data) => {
    setNewMaterial({
      ...data,
      skipQuantityInBill: false, // ✅ Allow manual quantity entry
    });
    setShowAddModal(false);

    if (!data.bill) {
      setTimeout(() => setShowUploadModal(true), 300);
    }
  };






  const handleUploadBill = (materialData) => {

    if (!materialData || typeof materialData !== 'object') {
      console.error('❌ Invalid materialData passed to handleUploadBill');
      return;
    }

    const { quantityToBill, skipQuantityInBill, ...rest } = materialData;

    const modalMaterial = {
      ...rest,
      quantityToBill: quantityToBill || 0,
      skipQuantityInBill: !!skipQuantityInBill,
    };

    setNewMaterial(modalMaterial);
    setShowUploadModal(true);
  };





  const openTransactionModal = (mat, mode) => {
    setTransactionMaterial(mat);
    setTransactionMode(mode);
  };

  const closeTransactionModal = () => {
    setTransactionMaterial(null);
    setTransactionMode(null);
  };

  const handleTransactionSubmit = async (actionLabel = 'Updated') => {
    closeTransactionModal();

    try {
      await Promise.allSettled([
        dispatch(fetchMaterialsByProject(currentProjectId)).unwrap(),
        dispatch(fetchMaterialOverview(currentProjectId)).unwrap(),
        dispatch(fetchRecentMaterialActivity({ projectId: currentProjectId, limit: 4 })).unwrap(),
      ]);

      toast.success(`✅ ${actionLabel} successfully`);
    } catch (e) {
      toast.error('❌ Failed to refresh material data');
    }
  };





  const handleLogMoreUsage = (material) => {
    openTransactionModal(material, 'log');
  };


  const handleUploadAnotherBill = (material) => {
    const hasPending = (material.billHistory || []).some(
      (b) => (b.status || '').toLowerCase() === 'processing'
    );

    if (!hasPending) {
      const ok = window.confirm('No pending bills. Upload anyway?');
      if (!ok) return;
    }

    setNewMaterial({ ...material, skipQuantityInBill: true });
    setShowUploadModal(true);
  };



  const confirm = (msg) => window.confirm(msg);

  const handleArchive = async (mat) => {
    askConfirm({
      title: 'Archive material?',
      message: `Archive "${mat.name}"? You can restore later.`,
      onYes: async () => {
        try {
          await dispatch(deleteMaterialById({ materialId: mat._id, projectId: currentProjectId })).unwrap();
          dispatch(showFeedback({ type: 'success', title: 'Archived', message: 'Material archived successfully.' }));
          dispatch(fetchMaterialOverview(currentProjectId));
        } catch (e) {
          dispatch(showFeedback({ type: 'error', title: 'Archive failed', message: e?.message || 'Failed to archive.' }));
        }
      }
    });
    try {
      await dispatch(deleteMaterialById({ materialId: mat._id, projectId: currentProjectId })).unwrap();
      dispatch(showFeedback({ type: 'success', title: 'Archived', message: 'Material archived successfully.' }));
      dispatch(fetchMaterialOverview(currentProjectId));
    } catch (e) {
      dispatch(showFeedback({ type: 'error', title: 'Archive failed', message: e?.message || String(e) || 'Failed to archive.' }));
    }
  };

  const handleRestore = async (mat) => {
    try {
      await dispatch(restoreMaterialById({ materialId: mat._id, projectId: currentProjectId })).unwrap();
      dispatch(showFeedback({ type: 'success', title: 'Archived', message: 'Material restored successfully.' }));
      dispatch(fetchMaterialOverview(currentProjectId));
    } catch (e) {
      dispatch(showFeedback({ type: 'error', title: 'Restore failed', message: e?.message || String(e) || 'Failed to restore.' }));
    }
  };



  const handleExportMaterialCSV = async () => {
    if (!currentProjectId) {
      dispatch(showFeedback({ type: 'error', title: 'Missing project', message: 'Select a project before exporting.' }));
      return;
    }
    if (!reportFrom || !reportTo) {
      dispatch(showFeedback({ type: 'warning', title: 'Date range required', message: 'Select From and To dates to export the report.' }));
      return;
    }


    const params = new URLSearchParams({
      type: 'materials',
      projectId: currentProjectId,
      from: reportFrom,
      to: reportTo,
      detail: reportDetail || 'summary',
      // category: reportCategory, // for future if you want
      format: 'csv',
    }).toString();

    const url = `${API_ROUTES.GENERATE_REPORT}?${params}`;

    try {
      const res = await axiosWithAuth.get(url, { responseType: 'blob' });

      const blob = new Blob([res.data], {
        type: 'text/csv;charset=utf-8;',
      });

      const link = document.createElement('a');
      const href = window.URL.createObjectURL(blob);
      link.href = href;
      link.download = `material-report-${reportFrom}-to-${reportTo}.csv`;

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(href);
    } catch (err) {
      const msg =
        err?.response?.data?.message ||
        err?.message ||
        'Failed to export material CSV. Please try again.';
      dispatch(showFeedback({ type: 'error', title: 'Export failed', message: msg }));

    }
  };

  const handleExportMaterialPDF = () => {
    if (!currentProjectId) {
      dispatch(showFeedback({ type: 'error', title: 'Missing project', message: 'Select a project before exporting.' }));
      return;
    }
    if (!reportFrom || !reportTo) {
      dispatch(showFeedback({ type: 'warning', title: 'Date range required', message: 'Select From and To dates to export the report.' }));
      return;
    }


    const params = new URLSearchParams({
      type: 'materials',
      projectId: currentProjectId,
      from: reportFrom,
      to: reportTo,
      detail: reportDetail || 'summary',
      // category: reportCategory,
    }).toString();

    navigate(`/dashboard/material-report-preview?${params}`, {
      state: {
        returnTo: `/dashboard/project/${currentProjectId}?tab=Materials`,
      },
    });

    setShowReportModal(false);
  };




  return (
    <div className="material-tab-wrapper">
      {!loading && Array.isArray(materials) && materials.length === 0 ? (
        <EmptyState
          variant="material"
          icon={<FaPlus />}
          title="No materials added yet"
          subtitle="Add materials to manage inventory, usage, and bills."
          image={emptyIllustration}
          imageAlt="No materials"
          ctaLabel="Add Material"
          onCta={() => setShowAddModal(true)}
        />
      ) : (
        <>
          <div className="material-tab-header-panel">
            <div className="material-tab-metrics-box">
              <div className="material-tab-metric">
                <p>Total Materials</p>
                <h2>{overviewLoading ? '—' : `${(overview?.totalMaterials ?? materials.length)} Items`}</h2>
              </div>
              <div className="material-tab-metric-divider" />
              <div className="material-tab-metric">
                <p>Low Stock Items</p>
                <h2>{overviewLoading ? '—' : (overview?.lowStockItems ?? 0)}</h2>
              </div>
              <div className="material-tab-metric-divider" />
              <div className="material-tab-metric">
                <p>Pending Bills</p>
                <h2>{overviewLoading ? '—' : (overview?.pendingBills ?? 0)}</h2>
              </div>
              <div className="material-tab-metric-divider" />
              <div className="material-tab-metric">
                <p>Total Spend</p>
                <h2>{overviewLoading ? '—' : fmtINR(overview?.totalSpend ?? 0)}</h2>
              </div>
            </div>

            <div className="material-tab-quick-actions">
              <button className="material-tab-quick-btn" onClick={() => setShowAddModal(true)}>
                <FaPlus />
                <span>Add New Material</span>
              </button>
              <button
                className="material-tab-quick-btn"
                onClick={() => setShowReportModal(true)}
              >
                <FaClipboardList />
                <span>View Report</span>
              </button>

            </div>
          </div>






          <div className="material-tab-main-content">
            <div className="material-tab-left">
              <MaterialActionPanel
                materials={materials}
                projectId={currentProjectId}
                onUploadBill={handleUploadBill}
                onOpenLogUsageModal={({ material, prefill }) => {
                  setTransactionMode(null);
                  setTransactionMaterial(null);
                  setLogModalData({ material, prefill });
                }}
              />
              <br></br>
              <MaterialInventoryTable
                materials={materials}
                projectId={currentProjectId}
                onUploadBill={(mat) => {
                  setNewMaterial({ ...mat, skipQuantityInBill: true });
                  setShowUploadModal(true);
                }}
                onIssueMaterial={(mat) => {
                  toast.info('📦 Material issued. Please log usage to update stock.', { autoClose: 4000 });
                  openTransactionModal(mat, 'log');
                }}
                onLogUsage={(mat) => openTransactionModal(mat, 'log')}
                onViewItem={(mat) => {
                  setSelectedMaterialId(mat._id);
                  dispatch(fetchMaterialDetails(mat._id));
                }}
                onDelete={handleArchive}      // single Delete = soft delete
                onRestore={handleRestore}
              />




            </div>


            <div className="material-tab-right">
              <RecentActivity
                logs={uiLogs}
                hasMore={!!recentActivityNextCursor}
                loading={recentActivityLoading}
                onLoadMore={() =>
                  dispatch(fetchMoreMaterialActivity({
                    projectId: currentProjectId,
                    cursor: recentActivityNextCursor,
                    limit: 4
                  }))
                }
              />
              {/* 🔒 Coming Soon mask over SmartSuggestions */}
              <div className="csl-wrap" aria-disabled="true">
                <div className="csl-content">
                  <SmartSuggestions
                    suggestions={suggestionData}
                    onRemove={handleRemoveSuggestion}
                  />
                </div>

                <div className="csl-overlay">
                  <div className="csl-card">
                    <div className="csl-icon">{/* use an icon or emoji */}<FiZap /></div>
                    <div className="csl-title">Smart Suggestions</div>
                    <div className="csl-sub">Coming soon</div>
                    <span className="csl-pill">Auto actions · Low stock insights</span>
                  </div>
                </div>
              </div>

            </div>
          </div>






        </>
      )}

      {showAddModal && (
        <AddMaterialModal
          onClose={() => setShowAddModal(false)}
          onSubmit={handleAddMaterial}
          currentProjectId={currentProjectId}
          onShowUploadModal={(createdMaterial) => {
            setNewMaterial(createdMaterial);
            setShowUploadModal(true);
          }}
        />
      )}




      {showUploadModal && newMaterial && (
        <>
          <UploadBillModal
            material={newMaterial}
            projectId={currentProjectId}
            onClose={() => {
              setShowUploadModal(false);
              setNewMaterial(null);
            }}
          />
        </>
      )}









      {showReportModal && (
        <MaterialReportModal
          show={showReportModal}
          onClose={() => setShowReportModal(false)}
          startDate={reportFrom}
          endDate={reportTo}
          setStartDate={setReportFrom}
          setEndDate={setReportTo}
          category={reportCategory}
          setCategory={setReportCategory}
          format={reportDetail}
          setFormat={setReportDetail}
          handleExportCSV={handleExportMaterialCSV}
          handleExportPDF={handleExportMaterialPDF}
        />
      )}






      {transactionMode && (transactionMaterial || materials.length > 0) && (
        <MaterialTransactionModal
          mode={transactionMode}
          material={transactionMaterial}
          allMaterials={materials}
          projectId={currentProjectId}
          onClose={closeTransactionModal}
        />
      )}

      {logModalData && (
        <MaterialTransactionModal
          mode="log"
          material={logModalData.material}
          allMaterials={materials}
          projectId={currentProjectId}
          prefill={logModalData.prefill}
          onClose={() => setLogModalData(null)}
        />
      )}





      {selectedMaterialId && (
        <ViewMaterialDrawer
          projectId={currentProjectId}
          material={materialDetails}
          isLoading={materialDetailsLoading}
          onClose={() => {
            setSelectedMaterialId(null);
            dispatch(clearMaterialDetails());
          }}
          onLogMoreUsage={handleLogMoreUsage}
          onUploadAnotherBill={handleUploadAnotherBill}
          onViewFullLog={(mat) => {
            setLogMaterial(mat);
            setShowUsageLogModal(true);
          }}
          onDelete={() => materialDetails && handleArchive(materialDetails)}
        />
      )}




      {showUsageLogModal && logMaterial && (
        <ViewUsageLogModal
          material={logMaterial}
          onClose={() => {
            setShowUsageLogModal(false);
            setLogMaterial(null);
          }}
        />
      )}


      {confirmBox && (
        <div className="mat-confirm-overlay" onMouseDown={() => setConfirmBox(null)}>
          <div className="mat-confirm-modal" onMouseDown={(e) => e.stopPropagation()}>
            <h3>{confirmBox.title}</h3>
            <p>{confirmBox.message}</p>
            <div className="actions">
              <button
                className="btn black"s
                onClick={async () => {
                  const fn = confirmBox.onYes;
                  setConfirmBox(null);
                  await fn?.();
                }}
              >
                Yes
              </button>
              <button className="btn cancel" onClick={() => setConfirmBox(null)}>
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}


    </div>
  );
};

export default Materials;
